<script>
    import { user } from "../client.svelte.js";
	  import {exhibit_URL} from "../core.js";
    import Collapsible from "../elements/Collapsible.svelte";

    let grpdExhibits = $derived(
			Object.groupBy(
				user.exhibits.values()
				.filter(img => img.advtID === view.adventure.ID && (!view.section || img.sectID === view.section.SECT))
				.toArray()
				.toSorted((a, b) => a['title'].localeCompare(b['title']))
			, (image => image.sectID ?? "")))

    let sections = $derived(
		  view.adventure.sections
        .map(sectID => user.sections.get(sectID))
        .filter(sect => sect.SECT in grpdExhibits))

    $inspect(`IMAGEPANEL - grpImages`, grpdExhibits)

</script>


<!------------------------------- HTML ------------------------------------->

<div id=imagesTab>
	<br>
	{#each sections as sect}
    <Collapsible header={sect.name} expanded={sect?.SECT === view.section?.SECT}>
      <div class=imagesGrid>
        {#each grpdExhibits[sect.SECT] as exhibit}
          <img src={exhibit_URL(exhibit)} alt={exhibit.title} title={exhibit.ID} onclick={() => view.exhibit = exhibit}>
          <h4>{exhibit.name}</h4>
        {/each}
      </div>
    </Collapsible>
	{/each}
</div>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.imagesGrid
		display: grid
		grid-template-columns: 224px auto
		grid-gap: 1em

	h4
		margin: 0

	img
		width: 100%

</style>